import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Colors } from "../../helpers/Colors";
import { fontSize } from "../../helpers/fontSize";
import axios from "axios";
import Table_myReservations from "./section/Table_myCabins";
import Table_myCabins from "./section/Table_myCabins";
import { ax_getCabins } from "../../api/cabin";

const useStyles = makeStyles({
  Reservation: {
    backgroundColor: Colors.primaryExtraLight2,
    width: "auto",
    // height: "100vh",
    overflow: "auto",
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-Width: 770px) ": {
      padding: "5px 10px",
    },
    // // --------ipad
    "@media (min-width: 770px) and (max-width: 1025px)": {
      padding: "10px 25px",
    },
    // --------desktop
    "@media (min-width: 1025px) and (max-Width: 2560px) ": {
      padding: "10px 25px",
    },
  },
  Content: {
    width: "100%",
    height: "100%",
    backgroundColor: Colors.primaryExtraLight2,
    "& .heading": {
      padding: "0px 0px 15px 0",
      fontSize: fontSize.heading,
      fontWeight: 500,
      // --------- from xs(380px) till md(770px)
      "@media only screen and (max-Width: 770px)": {
        fontSize: fontSize.question,
      },
      "@media only screen and (max-Width: 900px)": {
        padding: "0px 0px 0px 0",
      },
    },
    "& .subHeading": {
      padding: "10px 25px",
      fontSize: fontSize.question,
      fontWeight: 400,
    },
    "& .Overall_Date_Con": {
      // backgroundColor: Colors.success,
      // padding: "0px 25px",
      // fontSize: fontSize.heading,
      // fontWeight: 500,
    },
    "& .Overall_Time_Con": {
      // backgroundColor: Colors.grey,
    },
  },
});

const MyCabins = ({ user, triggerUseEffect, setUseEffect }) => {
  const classes = useStyles();
  const [myCabins, setMyCabins] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  useEffect(() => {
    const ax_fetch = async () => {
      try {
        const ax = await ax_getCabins();
        console.log("ax_getCabins -> ", JSON.stringify(ax));
        if (ax.code === 200) {
          setMyCabins(ax.data);
          setUseEffect(true);
        }
      } catch (e) {
        console.log("Error while retriving Cabins: " + e);
      }
    };
    ax_fetch();
  }, [triggerUseEffect, showEditModal]);

  return (
    <main
      className={`${classes.Reservation}`}
      style={{ height: "calc(100vh - 58px)" }}
    >
      <section
        // className={`${classes.Content} max-w-md px-4 mx-auto sm:px-7 md:max-w-4xl md:px-6`}
        className={`${classes.Content} `}
        // max-w-md px-4 mx-auto sm:px-7 md:max-w-4xl md:px-6
      >
        <section className="p-2 900px:px-0 900px:py-2 flex items-center justify-between">
          <div className="heading">My Cabins - ({myCabins.length})</div>
        </section>

        <div className="Overall_Date_Con">
          <Table_myCabins
            myCabins={myCabins}
            showEditModal={showEditModal}
            setShowEditModal={setShowEditModal}
            showCancelModal={showCancelModal}
            setShowCancelModal={setShowCancelModal}
            triggerUseEffect={triggerUseEffect}
            setUseEffect={setUseEffect}
          />
        </div>
      </section>
    </main>
  );
};

export default MyCabins;
